import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const ChevronDown: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M5.29 8.29a1 1 0 0 1 1.42 0l5.29 5.3 5.29-5.3a1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.41l-6 6a1 1 0 0 1-1.42 0l-6-6a1 1 0 0 1 0-1.41Z" />
  </Icon>
);

export default ChevronDown;
